/**
 * 🎤 Equipment Data - Cetalingua FM
 * Hydrophones, recorders, sampling rates, projects, environments
 */

// Sampling rates (per user spec)
export const SAMPLING_RATES = [
  { id: '6', label: '6 kHz' },
  { id: '8', label: '8 kHz' },
  { id: '120Hz', label: '120 Hz' },
  { id: '48', label: '48 kHz' },
  { id: '96', label: '96 kHz' },
  { id: '250', label: '250 kHz' },
  { id: 'custom', label: 'Custom' },
];

// Hydrophone types
export const HYDROPHONES = [
  { id: 'wilcoxon', name: 'Wilcoxon' },
  { id: 'reson', name: 'Reson' },
  { id: 'hti99', name: 'HTI-99' },
  { id: 'soundtrap', name: 'Soundtrap' },
  { id: 'aquarian', name: 'Aquarian' },
  { id: 'bruel_kjaer', name: 'Brüel & Kjær' },
  { id: 'cetacean_research', name: 'Cetacean Research Technology' },
  { id: 'audiomoth', name: 'Audiomoth' },
  { id: 'hydromoth', name: 'Hydromoth' },
  { id: 'umoth', name: 'uMoth' },
  { id: 'custom', name: 'Custom' },
  { id: 'other', name: 'Other' },
];

// Recorder types
export const RECORDERS = [
  { id: 'fostex', name: 'Fostex' },
  { id: 'zoom', name: 'Zoom' },
  { id: 'audiomoth', name: 'Audiomoth' },
  { id: 'hydromoth', name: 'Hydromoth' },
  { id: 'umoth', name: 'uMoth' },
  { id: 'soundtrap', name: 'Soundtrap' },
  { id: 'loggerhead', name: 'Loggerhead Instruments' },
  { id: 'rudar', name: 'Rudar Cetacean Research Technology' },
  { id: 'sony_dat', name: 'Sony DAT' },
  { id: 'maudio', name: 'M-Audio' },
  { id: 'custom', name: 'Custom' },
  { id: 'other', name: 'Other' },
];

// Project types (code used in filename)
export const PROJECTS = [
  { id: 'MC', name: 'Manatee Chat', icon: '🦭' },
  { id: 'DC', name: 'Dolphin Chat', icon: '🐬' },
  { id: 'WC', name: 'Whale Chat', icon: '🐋' },
];

// Environment types (numeric code used in filename)
export const ENVIRONMENTS = [
  { id: 1, name: 'Coastal' },
  { id: 2, name: 'Open Ocean' },
  { id: 3, name: 'Fresh Water' },
];

// Supported audio file extensions
export const SUPPORTED_EXTENSIONS = ['.wav', '.flac', '.mp3', '.aiff', '.ogg', '.mp4'];

export default {
  SAMPLING_RATES,
  HYDROPHONES,
  RECORDERS,
  PROJECTS,
  ENVIRONMENTS,
  SUPPORTED_EXTENSIONS,
};
